// Components
import SwitchWidget from '../../ControlPanel/SwitchWidget';

// Elements
import { Input, Textarea } from '~/elements/Input';
import Select from '~/elements/Select';

const SettingsTab = ({ t, form, isCreate, onChange, onKeyChange, categoryOptions, priorityOptions }) => (
    <div>
        {isCreate && (
            <>
                <div className="mb-3">
                    <label className="control-label mb-1">{t('Category')}</label>
                    <Select
                        options={categoryOptions}
                        value={categoryOptions.find((o) => o.value === form.category) || null}
                        onChange={(opt) => onChange('category', opt.value)}
                    />
                </div>
                <div className="mb-3">
                    <Input
                        label={t('Key')}
                        value={form.key}
                        onChange={onKeyChange}
                        placeholder="E.G. SUBSCRIPTION_TRIAL_ENDING"
                    />
                    <small className="text-muted fst-italic d-block">{t('Use only capital letters and underscores')}, e.g. SUBSCRIPTION_TRIAL_ENDING.</small>
                </div>
                <div className="mb-3">
                    <Textarea
                        label={t('Description')}
                        value={form.description}
                        onChange={(e) => onChange('description', e.target.value)}
                        placeholder={t('E.g. Notify the employee 3 days before their subscription trial ends.')}
                    />
                </div>
                <hr />
            </>
        )}
        <div className="d-flex align-items-center justify-content-between mb-3">
            <label className="control-label">{t('Active')}</label>
            <SwitchWidget
                value={form.is_active}
                onChange={(val) => onChange('is_active', val)}
            />
        </div>
        <div className="d-flex align-items-center justify-content-between mb-3">
            <label className="control-label">{t('Push')} {t('Notifications')}</label>
            <SwitchWidget
                value={form.allow_push}
                onChange={(val) => onChange('allow_push', val)}
                disabled={!form.is_active}
            />
        </div>
        <div className="d-flex align-items-center justify-content-between mb-3">
            <label className="control-label">{t('Email')} {t('Notifications')}</label>
            <SwitchWidget
                value={form.allow_email}
                onChange={(val) => onChange('allow_email', val)}
                disabled={!form.is_active}
            />
        </div>
        <div className="d-flex align-items-center justify-content-between mb-3">
            <label className="control-label">{t('System')} {t('Notifications')}</label>
            <SwitchWidget
                value={form.allow_system}
                onChange={(val) => onChange('allow_system', val)}
                disabled={!form.is_active}
            />
        </div>
        <div className="d-flex align-items-center justify-content-between mb-3">
            <label className="control-label">{t('Batch Notification')}</label>
            <SwitchWidget
                value={form.is_batch_notification}
                onChange={(val) => onChange('is_batch_notification', val)}
                disabled={!form.is_active}
            />
        </div>
        <div className="d-flex align-items-center justify-content-between mb-3">
            <label className="control-label">{t('Allow admins to customize notification messages')}</label>
            <SwitchWidget
                value={form.is_message_customizable}
                onChange={(val) => onChange('is_message_customizable', val)}
                disabled={!form.is_active || form.is_batch_notification}
            />
        </div>
        <div className="mt-4">
            <label className='control-label'>{t('Priority')}</label>
            <Select
                options={priorityOptions}
                value={priorityOptions.find((o) => o.value === form.priority) || null}
                onChange={(opt) => onChange('priority', opt.value)}
            />
        </div>
    </div>
);

export default SettingsTab;
